export default class MediaHelper {
    static DataWebImageBasePath: string = "/dataweb/media/image";
    static DataWebDocumentBasePath: string = "/dataweb/media/document";

    static getDataWebImageUrl(code: String, width: Number, height: Number, resizemode: String, nav: String, versionName: string = null, tagName: string = null, isCutDisabled: boolean = false, hash: string = null) {
        let url = this.DataWebImageBasePath + "?code=" + code + "&width=" + width.toString() + "&height=" + height.toString() + "&resizemode=" + resizemode.toLocaleLowerCase() + "&nav=" + nav;

        if (versionName) {
            url += "&versionname=" + versionName;
        }

        if (tagName) {
            url += "&tagname=" + tagName;
        }

        if (isCutDisabled === true) {
            url += "&iscutdisabled=" + isCutDisabled;
        }

        if (hash) {
            url += "&" + hash;
        }

        return url;
    }

    static getDataWebDocumentUrl(code: String, nav: String, versionName: string = null, tagName: string = null) {
        let url = this.DataWebDocumentBasePath + "?code=" + code + "&nav=" + nav;

        if (versionName) {
            url += "&versionname=" + versionName;
        }

        if (tagName) {
            url += "&tagname=" + tagName;
        }

        return url;
    }

    static bytesToString(bytes: number) {
        var thresh = 1024;
        if (bytes < thresh) return bytes + " B";
        var units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        var u = -1;

        do {
            bytes /= thresh;
            ++u;
        } while (bytes >= thresh);

        return bytes.toFixed(1) + " " + units[u];
    }

    static isQueryParams(url: string): boolean {
        try {
            const completeUrl = url.startsWith('/') ? `http://example.com${url}` : url;
            const parsedUrl = new URL(completeUrl);
            return parsedUrl.searchParams.toString() !== '';
        } catch (e) {
            return false;
        }
    }
}